<template>
  <div class="w-full">
    <WebccInput
      v-model="email"
      class="mb-4"
      name="email"
      :label="t(`${trPrefix}email`)"
      type="email"
      :valid="isEmailValid"
      @keyup.enter.stop="submit"
    />
    <WebccFeedbackMessage
      v-if="errorMessage"
      type="error"
      :message="errorMessage"
      class="mb-4"
    />

    <WebccButton
      class="mb-4 w-full"
      variant="theme"
      size="lg"
      :loading="requestPending"
      @click="submit"
    >
      {{ t(`${trPrefix}continue`) }}</WebccButton
    >
  </div>
</template>

<script lang="ts" setup>
const trPrefix = 'components.auth.register.registerFormEmail.'

const { t } = useI18n()

const email = ref('')
const errorMessage: Ref<string | undefined> = ref(undefined)
const requestPending: Ref<boolean> = ref(false)
const isEmailValid: Ref<boolean | undefined> = ref(undefined)

const emit = defineEmits<{
  submit: [email: string]
}>()

onMounted(() => {
  document.getElementById('email')?.focus()
})

onUnmounted(() => {
  // Reset the step
  email.value = ''
  errorMessage.value = undefined
  requestPending.value = false
  isEmailValid.value = undefined
})

async function submit() {
  isEmailValid.value = undefined

  // Check the email validity
  if (!email.value || !email.value.includes('@')) {
    errorMessage.value = 'Invalid email address'
    isEmailValid.value = false
    return
  }

  requestPending.value = true
  try {
    const response = await useValidation().email(email.value)
    // Email is valid -> check if the score is above 3
    if (response && response.score < 3) {
      errorMessage.value = t(`${trPrefix}emailError`)
      isEmailValid.value = false
      requestPending.value = false
      return
    }
  } catch {
    errorMessage.value = t(`${trPrefix}emailError`)
    isEmailValid.value = false
    requestPending.value = false
    return
  }

  requestPending.value = false
  emit('submit', email.value)
}

// Watch the email input for changes and set the error and valid state according to it
watch(email, () => {
  errorMessage.value = undefined
  isEmailValid.value = undefined
})
</script>

<style></style>
